module.exports = __webpack_public_path__ + "img/frame20_current.0a883dae.png";